import { render } from "./BaseButtonStyle.vue?vue&type=template&id=012cdea3&scoped=true"
import script from "./BaseButtonStyle.vue?vue&type=script&lang=js"
export * from "./BaseButtonStyle.vue?vue&type=script&lang=js"

import "./BaseButtonStyle.vue?vue&type=style&index=0&id=012cdea3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012cdea3"]])

export default __exports__